<template>
  <b-field :label="label">
    <b-autocomplete
      :value="searchCampagne"
      :data="filteredData"
      :loading="isLoad"
      @select="setCampagne"
      @input="getItems"
      field="libelle"
      icon="magnify"
      type="is-primary">
      <template slot="empty">
        <div v-if="!isLoad">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>
          {{$t('general.autocomplete.search')}}
        </div>
      </template>
      <template slot-scope="props">
        <div class="columns is-vcentered">
            <div class="column is-8 is-prewrap">
              {{ props.option.libelle }}
            </div>
            <div class="column is-4 has-text-right"
              v-if="props.option.urlLogoCampagne">
              <div class="max-height-img-view-80">
                <img :src="props.option.urlLogoCampagne"
                  class="max-width-100 max-height-80">
              </div>
            </div>
        </div>
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getAll } from '@/api/campagne/index';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { RESULTS_PER_PAGE } from '@/configuration/clientTableConf';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'SelecteurCampagne',
  props: {
    label: {
      type: String,
      required: true,
    },
    dcf: {
      type: Object,
      required: true,
    },
    avecLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchCampagne: '',
      isLoad: false,
      filteredData: [],
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getItems: debounce(async function loadData(text) {
      if (!text) {
        this.dcf.campagne = null;
        this.dcf.campagneId = null;
        return;
      }
      if (text === this.searchCampagne) return;
      this.isLoad = true;
      try {
        this.filteredData = (await getAll({
          query: {
            auto: text,
            actif: true,
            societeId: this.societeActiveId,
            avecLogo: this.avecLogo,
          },
          skipCount: 0,
          maxResultCount: RESULTS_PER_PAGE,
        })).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        this.isLoad = false;
      }
    }, 300),
    setCampagne(campagne) {
      if (!campagne) return;
      this.searchCampagne = campagne.libelle;
      this.dcf.theme = campagne.libelle;
      this.dcf.campagne = campagne;
      this.dcf.campagneId = campagne.id;
    },
  },
  mounted() {
    try {
      if (this.dcf && this.dcf.campagne) {
        this.searchCampagne = this.dcf.campagne.libelle;
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style>

</style>
